/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcademyTemplate,
  AdCampaign,
  AdCampaignDetail,
  AdCampaignRequest,
  AdCreative,
  AdCreativeRequest,
  AdsCampaignsAcademyTemplatesListParams,
  AdsCampaignsAttributionRetrieveParams,
  AdsCampaignsListParams,
  AdsCampaignsRoiRetrieveParams,
  AdsCreativesListParams,
  AdsMode,
  Attribution,
  FromAcademyTemplateRequest,
  FromOfferRequest,
  GlobalReport,
  Metrics,
  PaginatedAdCampaignList,
  PaginatedAdCreativeList,
  PatchedAdCampaignRequest,
  ResumeRequest
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type adsCampaignsListResponse200 = {
  data: PaginatedAdCampaignList
  status: 200
}
    
export type adsCampaignsListResponseSuccess = (adsCampaignsListResponse200) & {
  headers: Headers;
};
;

export type adsCampaignsListResponse = (adsCampaignsListResponseSuccess)

export const getAdsCampaignsListUrl = (params?: AdsCampaignsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/ads/campaigns/?${stringifiedParams}` : `/api/v1/ads/campaigns/`
}

export const adsCampaignsList = async (params?: AdsCampaignsListParams, options?: RequestInit): Promise<adsCampaignsListResponse> => {
  
  return apiFetch<adsCampaignsListResponse>(getAdsCampaignsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAdsCampaignsListQueryKey = (params?: AdsCampaignsListParams,) => {
    return [
    `/api/v1/ads/campaigns/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdsCampaignsListQueryOptions = <TData = Awaited<ReturnType<typeof adsCampaignsList>>, TError = unknown>(params?: AdsCampaignsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdsCampaignsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adsCampaignsList>>> = ({ signal }) => adsCampaignsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdsCampaignsListQueryResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsList>>>
export type AdsCampaignsListQueryError = unknown


export function useAdsCampaignsList<TData = Awaited<ReturnType<typeof adsCampaignsList>>, TError = unknown>(
 params: undefined |  AdsCampaignsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCampaignsList>>,
          TError,
          Awaited<ReturnType<typeof adsCampaignsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCampaignsList<TData = Awaited<ReturnType<typeof adsCampaignsList>>, TError = unknown>(
 params?: AdsCampaignsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCampaignsList>>,
          TError,
          Awaited<ReturnType<typeof adsCampaignsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCampaignsList<TData = Awaited<ReturnType<typeof adsCampaignsList>>, TError = unknown>(
 params?: AdsCampaignsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdsCampaignsList<TData = Awaited<ReturnType<typeof adsCampaignsList>>, TError = unknown>(
 params?: AdsCampaignsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdsCampaignsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type adsCampaignsCreateResponse201 = {
  data: AdCampaign
  status: 201
}
    
export type adsCampaignsCreateResponseSuccess = (adsCampaignsCreateResponse201) & {
  headers: Headers;
};
;

export type adsCampaignsCreateResponse = (adsCampaignsCreateResponseSuccess)

export const getAdsCampaignsCreateUrl = () => {


  

  return `/api/v1/ads/campaigns/`
}

export const adsCampaignsCreate = async (adCampaignRequest: AdCampaignRequest, options?: RequestInit): Promise<adsCampaignsCreateResponse> => {
  
  return apiFetch<adsCampaignsCreateResponse>(getAdsCampaignsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adCampaignRequest,)
  }
);}




export const getAdsCampaignsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsCreate>>, TError,{data: AdCampaignRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsCreate>>, TError,{data: AdCampaignRequest}, TContext> => {

const mutationKey = ['adsCampaignsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adsCampaignsCreate>>, {data: AdCampaignRequest}> = (props) => {
          const {data} = props ?? {};

          return  adsCampaignsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdsCampaignsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsCreate>>>
    export type AdsCampaignsCreateMutationBody = AdCampaignRequest
    export type AdsCampaignsCreateMutationError = unknown

    export const useAdsCampaignsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsCreate>>, TError,{data: AdCampaignRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adsCampaignsCreate>>,
        TError,
        {data: AdCampaignRequest},
        TContext
      > => {

      const mutationOptions = getAdsCampaignsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type adsCampaignsRetrieveResponse200 = {
  data: AdCampaignDetail
  status: 200
}
    
export type adsCampaignsRetrieveResponseSuccess = (adsCampaignsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adsCampaignsRetrieveResponse = (adsCampaignsRetrieveResponseSuccess)

export const getAdsCampaignsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/ads/campaigns/${id}/`
}

export const adsCampaignsRetrieve = async (id: string, options?: RequestInit): Promise<adsCampaignsRetrieveResponse> => {
  
  return apiFetch<adsCampaignsRetrieveResponse>(getAdsCampaignsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAdsCampaignsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/ads/campaigns/${id}/`
    ] as const;
    }

    
export const getAdsCampaignsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adsCampaignsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdsCampaignsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adsCampaignsRetrieve>>> = ({ signal }) => adsCampaignsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdsCampaignsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsRetrieve>>>
export type AdsCampaignsRetrieveQueryError = unknown


export function useAdsCampaignsRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCampaignsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adsCampaignsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCampaignsRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCampaignsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adsCampaignsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCampaignsRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdsCampaignsRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdsCampaignsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type adsCampaignsPartialUpdateResponse200 = {
  data: AdCampaign
  status: 200
}
    
export type adsCampaignsPartialUpdateResponseSuccess = (adsCampaignsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adsCampaignsPartialUpdateResponse = (adsCampaignsPartialUpdateResponseSuccess)

export const getAdsCampaignsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/ads/campaigns/${id}/`
}

export const adsCampaignsPartialUpdate = async (id: string,
    patchedAdCampaignRequest: PatchedAdCampaignRequest, options?: RequestInit): Promise<adsCampaignsPartialUpdateResponse> => {
  
  return apiFetch<adsCampaignsPartialUpdateResponse>(getAdsCampaignsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedAdCampaignRequest,)
  }
);}




export const getAdsCampaignsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsPartialUpdate>>, TError,{id: string;data: PatchedAdCampaignRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsPartialUpdate>>, TError,{id: string;data: PatchedAdCampaignRequest}, TContext> => {

const mutationKey = ['adsCampaignsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adsCampaignsPartialUpdate>>, {id: string;data: PatchedAdCampaignRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  adsCampaignsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdsCampaignsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsPartialUpdate>>>
    export type AdsCampaignsPartialUpdateMutationBody = PatchedAdCampaignRequest
    export type AdsCampaignsPartialUpdateMutationError = unknown

    export const useAdsCampaignsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsPartialUpdate>>, TError,{id: string;data: PatchedAdCampaignRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adsCampaignsPartialUpdate>>,
        TError,
        {id: string;data: PatchedAdCampaignRequest},
        TContext
      > => {

      const mutationOptions = getAdsCampaignsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type adsCampaignsDestroyResponse204 = {
  data: void
  status: 204
}
    
export type adsCampaignsDestroyResponseSuccess = (adsCampaignsDestroyResponse204) & {
  headers: Headers;
};
;

export type adsCampaignsDestroyResponse = (adsCampaignsDestroyResponseSuccess)

export const getAdsCampaignsDestroyUrl = (id: string,) => {


  

  return `/api/v1/ads/campaigns/${id}/`
}

export const adsCampaignsDestroy = async (id: string, options?: RequestInit): Promise<adsCampaignsDestroyResponse> => {
  
  return apiFetch<adsCampaignsDestroyResponse>(getAdsCampaignsDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getAdsCampaignsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['adsCampaignsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adsCampaignsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  adsCampaignsDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdsCampaignsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsDestroy>>>
    
    export type AdsCampaignsDestroyMutationError = unknown

    export const useAdsCampaignsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adsCampaignsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAdsCampaignsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type adsCampaignsPauseCreateResponse202 = {
  data: AdCampaign
  status: 202
}
    
export type adsCampaignsPauseCreateResponseSuccess = (adsCampaignsPauseCreateResponse202) & {
  headers: Headers;
};
;

export type adsCampaignsPauseCreateResponse = (adsCampaignsPauseCreateResponseSuccess)

export const getAdsCampaignsPauseCreateUrl = (id: string,) => {


  

  return `/api/v1/ads/campaigns/${id}/pause/`
}

export const adsCampaignsPauseCreate = async (id: string, options?: RequestInit): Promise<adsCampaignsPauseCreateResponse> => {
  
  return apiFetch<adsCampaignsPauseCreateResponse>(getAdsCampaignsPauseCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAdsCampaignsPauseCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsPauseCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsPauseCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['adsCampaignsPauseCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adsCampaignsPauseCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  adsCampaignsPauseCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdsCampaignsPauseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsPauseCreate>>>
    
    export type AdsCampaignsPauseCreateMutationError = unknown

    export const useAdsCampaignsPauseCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsPauseCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adsCampaignsPauseCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAdsCampaignsPauseCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type adsCampaignsReportRetrieveResponse200 = {
  data: Metrics
  status: 200
}
    
export type adsCampaignsReportRetrieveResponseSuccess = (adsCampaignsReportRetrieveResponse200) & {
  headers: Headers;
};
;

export type adsCampaignsReportRetrieveResponse = (adsCampaignsReportRetrieveResponseSuccess)

export const getAdsCampaignsReportRetrieveUrl = (id: string,) => {


  

  return `/api/v1/ads/campaigns/${id}/report/`
}

export const adsCampaignsReportRetrieve = async (id: string, options?: RequestInit): Promise<adsCampaignsReportRetrieveResponse> => {
  
  return apiFetch<adsCampaignsReportRetrieveResponse>(getAdsCampaignsReportRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAdsCampaignsReportRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/ads/campaigns/${id}/report/`
    ] as const;
    }

    
export const getAdsCampaignsReportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdsCampaignsReportRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>> = ({ signal }) => adsCampaignsReportRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdsCampaignsReportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>>
export type AdsCampaignsReportRetrieveQueryError = unknown


export function useAdsCampaignsReportRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCampaignsReportRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCampaignsReportRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdsCampaignsReportRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsReportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdsCampaignsReportRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Turns the campaign on at Meta: may spend real money in real mode, so it is confirmed.
 */
export type adsCampaignsResumeCreateResponse202 = {
  data: AdCampaign
  status: 202
}
    
export type adsCampaignsResumeCreateResponseSuccess = (adsCampaignsResumeCreateResponse202) & {
  headers: Headers;
};
;

export type adsCampaignsResumeCreateResponse = (adsCampaignsResumeCreateResponseSuccess)

export const getAdsCampaignsResumeCreateUrl = (id: string,) => {


  

  return `/api/v1/ads/campaigns/${id}/resume/`
}

export const adsCampaignsResumeCreate = async (id: string,
    resumeRequest: ResumeRequest, options?: RequestInit): Promise<adsCampaignsResumeCreateResponse> => {
  
  return apiFetch<adsCampaignsResumeCreateResponse>(getAdsCampaignsResumeCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      resumeRequest,)
  }
);}




export const getAdsCampaignsResumeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsResumeCreate>>, TError,{id: string;data: ResumeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsResumeCreate>>, TError,{id: string;data: ResumeRequest}, TContext> => {

const mutationKey = ['adsCampaignsResumeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adsCampaignsResumeCreate>>, {id: string;data: ResumeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  adsCampaignsResumeCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdsCampaignsResumeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsResumeCreate>>>
    export type AdsCampaignsResumeCreateMutationBody = ResumeRequest
    export type AdsCampaignsResumeCreateMutationError = unknown

    export const useAdsCampaignsResumeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsResumeCreate>>, TError,{id: string;data: ResumeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adsCampaignsResumeCreate>>,
        TError,
        {id: string;data: ResumeRequest},
        TContext
      > => {

      const mutationOptions = getAdsCampaignsResumeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * A creation refused by Meta is sent again (the ids already created are kept).
 */
export type adsCampaignsRetryCreateResponse202 = {
  data: AdCampaign
  status: 202
}
    
export type adsCampaignsRetryCreateResponseSuccess = (adsCampaignsRetryCreateResponse202) & {
  headers: Headers;
};
;

export type adsCampaignsRetryCreateResponse = (adsCampaignsRetryCreateResponseSuccess)

export const getAdsCampaignsRetryCreateUrl = (id: string,) => {


  

  return `/api/v1/ads/campaigns/${id}/retry/`
}

export const adsCampaignsRetryCreate = async (id: string, options?: RequestInit): Promise<adsCampaignsRetryCreateResponse> => {
  
  return apiFetch<adsCampaignsRetryCreateResponse>(getAdsCampaignsRetryCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAdsCampaignsRetryCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsRetryCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsRetryCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['adsCampaignsRetryCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adsCampaignsRetryCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  adsCampaignsRetryCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdsCampaignsRetryCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsRetryCreate>>>
    
    export type AdsCampaignsRetryCreateMutationError = unknown

    export const useAdsCampaignsRetryCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsRetryCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adsCampaignsRetryCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAdsCampaignsRetryCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type adsCampaignsSyncCreateResponse202 = {
  data: AdCampaign
  status: 202
}
    
export type adsCampaignsSyncCreateResponseSuccess = (adsCampaignsSyncCreateResponse202) & {
  headers: Headers;
};
;

export type adsCampaignsSyncCreateResponse = (adsCampaignsSyncCreateResponseSuccess)

export const getAdsCampaignsSyncCreateUrl = (id: string,) => {


  

  return `/api/v1/ads/campaigns/${id}/sync/`
}

export const adsCampaignsSyncCreate = async (id: string, options?: RequestInit): Promise<adsCampaignsSyncCreateResponse> => {
  
  return apiFetch<adsCampaignsSyncCreateResponse>(getAdsCampaignsSyncCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAdsCampaignsSyncCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsSyncCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsSyncCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['adsCampaignsSyncCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adsCampaignsSyncCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  adsCampaignsSyncCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdsCampaignsSyncCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsSyncCreate>>>
    
    export type AdsCampaignsSyncCreateMutationError = unknown

    export const useAdsCampaignsSyncCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsSyncCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adsCampaignsSyncCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAdsCampaignsSyncCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-111: ready-made Academy campaigns, copies filled with the catalogue's price.
 */
export type adsCampaignsAcademyTemplatesListResponse200 = {
  data: AcademyTemplate[]
  status: 200
}
    
export type adsCampaignsAcademyTemplatesListResponseSuccess = (adsCampaignsAcademyTemplatesListResponse200) & {
  headers: Headers;
};
;

export type adsCampaignsAcademyTemplatesListResponse = (adsCampaignsAcademyTemplatesListResponseSuccess)

export const getAdsCampaignsAcademyTemplatesListUrl = (params?: AdsCampaignsAcademyTemplatesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/ads/campaigns/academy-templates/?${stringifiedParams}` : `/api/v1/ads/campaigns/academy-templates/`
}

export const adsCampaignsAcademyTemplatesList = async (params?: AdsCampaignsAcademyTemplatesListParams, options?: RequestInit): Promise<adsCampaignsAcademyTemplatesListResponse> => {
  
  return apiFetch<adsCampaignsAcademyTemplatesListResponse>(getAdsCampaignsAcademyTemplatesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAdsCampaignsAcademyTemplatesListQueryKey = (params?: AdsCampaignsAcademyTemplatesListParams,) => {
    return [
    `/api/v1/ads/campaigns/academy-templates/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdsCampaignsAcademyTemplatesListQueryOptions = <TData = Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>, TError = unknown>(params?: AdsCampaignsAcademyTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdsCampaignsAcademyTemplatesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>> = ({ signal }) => adsCampaignsAcademyTemplatesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdsCampaignsAcademyTemplatesListQueryResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>>
export type AdsCampaignsAcademyTemplatesListQueryError = unknown


export function useAdsCampaignsAcademyTemplatesList<TData = Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>, TError = unknown>(
 params: undefined |  AdsCampaignsAcademyTemplatesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCampaignsAcademyTemplatesList<TData = Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>, TError = unknown>(
 params?: AdsCampaignsAcademyTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCampaignsAcademyTemplatesList<TData = Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>, TError = unknown>(
 params?: AdsCampaignsAcademyTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdsCampaignsAcademyTemplatesList<TData = Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>, TError = unknown>(
 params?: AdsCampaignsAcademyTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsAcademyTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdsCampaignsAcademyTemplatesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * D-111: UTM -> lead -> Academy account -> plan, by campaign code.
 */
export type adsCampaignsAttributionRetrieveResponse200 = {
  data: Attribution
  status: 200
}
    
export type adsCampaignsAttributionRetrieveResponseSuccess = (adsCampaignsAttributionRetrieveResponse200) & {
  headers: Headers;
};
;

export type adsCampaignsAttributionRetrieveResponse = (adsCampaignsAttributionRetrieveResponseSuccess)

export const getAdsCampaignsAttributionRetrieveUrl = (params?: AdsCampaignsAttributionRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/ads/campaigns/attribution/?${stringifiedParams}` : `/api/v1/ads/campaigns/attribution/`
}

export const adsCampaignsAttributionRetrieve = async (params?: AdsCampaignsAttributionRetrieveParams, options?: RequestInit): Promise<adsCampaignsAttributionRetrieveResponse> => {
  
  return apiFetch<adsCampaignsAttributionRetrieveResponse>(getAdsCampaignsAttributionRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAdsCampaignsAttributionRetrieveQueryKey = (params?: AdsCampaignsAttributionRetrieveParams,) => {
    return [
    `/api/v1/ads/campaigns/attribution/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdsCampaignsAttributionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>, TError = unknown>(params?: AdsCampaignsAttributionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdsCampaignsAttributionRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>> = ({ signal }) => adsCampaignsAttributionRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdsCampaignsAttributionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>>
export type AdsCampaignsAttributionRetrieveQueryError = unknown


export function useAdsCampaignsAttributionRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>, TError = unknown>(
 params: undefined |  AdsCampaignsAttributionRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCampaignsAttributionRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>, TError = unknown>(
 params?: AdsCampaignsAttributionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCampaignsAttributionRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>, TError = unknown>(
 params?: AdsCampaignsAttributionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdsCampaignsAttributionRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>, TError = unknown>(
 params?: AdsCampaignsAttributionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsAttributionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdsCampaignsAttributionRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * A campaign from an Academy template: PAUSED, in test mode unless the owner switched the
integration to real mode (a website objective always stays simulated).
 */
export type adsCampaignsFromAcademyTemplateCreateResponse201 = {
  data: AdCampaign
  status: 201
}
    
export type adsCampaignsFromAcademyTemplateCreateResponseSuccess = (adsCampaignsFromAcademyTemplateCreateResponse201) & {
  headers: Headers;
};
;

export type adsCampaignsFromAcademyTemplateCreateResponse = (adsCampaignsFromAcademyTemplateCreateResponseSuccess)

export const getAdsCampaignsFromAcademyTemplateCreateUrl = () => {


  

  return `/api/v1/ads/campaigns/from-academy-template/`
}

export const adsCampaignsFromAcademyTemplateCreate = async (fromAcademyTemplateRequest: FromAcademyTemplateRequest, options?: RequestInit): Promise<adsCampaignsFromAcademyTemplateCreateResponse> => {
  
  return apiFetch<adsCampaignsFromAcademyTemplateCreateResponse>(getAdsCampaignsFromAcademyTemplateCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      fromAcademyTemplateRequest,)
  }
);}




export const getAdsCampaignsFromAcademyTemplateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsFromAcademyTemplateCreate>>, TError,{data: FromAcademyTemplateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsFromAcademyTemplateCreate>>, TError,{data: FromAcademyTemplateRequest}, TContext> => {

const mutationKey = ['adsCampaignsFromAcademyTemplateCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adsCampaignsFromAcademyTemplateCreate>>, {data: FromAcademyTemplateRequest}> = (props) => {
          const {data} = props ?? {};

          return  adsCampaignsFromAcademyTemplateCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdsCampaignsFromAcademyTemplateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsFromAcademyTemplateCreate>>>
    export type AdsCampaignsFromAcademyTemplateCreateMutationBody = FromAcademyTemplateRequest
    export type AdsCampaignsFromAcademyTemplateCreateMutationError = unknown

    export const useAdsCampaignsFromAcademyTemplateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsFromAcademyTemplateCreate>>, TError,{data: FromAcademyTemplateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adsCampaignsFromAcademyTemplateCreate>>,
        TError,
        {data: FromAcademyTemplateRequest},
        TContext
      > => {

      const mutationOptions = getAdsCampaignsFromAcademyTemplateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « Lancer une campagne avec cette offre »: message with the code, copy, offer link.
 */
export type adsCampaignsFromOfferCreateResponse201 = {
  data: AdCampaign
  status: 201
}
    
export type adsCampaignsFromOfferCreateResponseSuccess = (adsCampaignsFromOfferCreateResponse201) & {
  headers: Headers;
};
;

export type adsCampaignsFromOfferCreateResponse = (adsCampaignsFromOfferCreateResponseSuccess)

export const getAdsCampaignsFromOfferCreateUrl = () => {


  

  return `/api/v1/ads/campaigns/from-offer/`
}

export const adsCampaignsFromOfferCreate = async (fromOfferRequest: FromOfferRequest, options?: RequestInit): Promise<adsCampaignsFromOfferCreateResponse> => {
  
  return apiFetch<adsCampaignsFromOfferCreateResponse>(getAdsCampaignsFromOfferCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      fromOfferRequest,)
  }
);}




export const getAdsCampaignsFromOfferCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsFromOfferCreate>>, TError,{data: FromOfferRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsFromOfferCreate>>, TError,{data: FromOfferRequest}, TContext> => {

const mutationKey = ['adsCampaignsFromOfferCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adsCampaignsFromOfferCreate>>, {data: FromOfferRequest}> = (props) => {
          const {data} = props ?? {};

          return  adsCampaignsFromOfferCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdsCampaignsFromOfferCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsFromOfferCreate>>>
    export type AdsCampaignsFromOfferCreateMutationBody = FromOfferRequest
    export type AdsCampaignsFromOfferCreateMutationError = unknown

    export const useAdsCampaignsFromOfferCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCampaignsFromOfferCreate>>, TError,{data: FromOfferRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adsCampaignsFromOfferCreate>>,
        TError,
        {data: FromOfferRequest},
        TContext
      > => {

      const mutationOptions = getAdsCampaignsFromOfferCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « Mode test » or « mode réel » of the Meta Marketing integration (shown everywhere).
 */
export type adsCampaignsModeRetrieveResponse200 = {
  data: AdsMode
  status: 200
}
    
export type adsCampaignsModeRetrieveResponseSuccess = (adsCampaignsModeRetrieveResponse200) & {
  headers: Headers;
};
;

export type adsCampaignsModeRetrieveResponse = (adsCampaignsModeRetrieveResponseSuccess)

export const getAdsCampaignsModeRetrieveUrl = () => {


  

  return `/api/v1/ads/campaigns/mode/`
}

export const adsCampaignsModeRetrieve = async ( options?: RequestInit): Promise<adsCampaignsModeRetrieveResponse> => {
  
  return apiFetch<adsCampaignsModeRetrieveResponse>(getAdsCampaignsModeRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAdsCampaignsModeRetrieveQueryKey = () => {
    return [
    `/api/v1/ads/campaigns/mode/`
    ] as const;
    }

    
export const getAdsCampaignsModeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdsCampaignsModeRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>> = ({ signal }) => adsCampaignsModeRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdsCampaignsModeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>>
export type AdsCampaignsModeRetrieveQueryError = unknown


export function useAdsCampaignsModeRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCampaignsModeRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCampaignsModeRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdsCampaignsModeRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsModeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdsCampaignsModeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type adsCampaignsRoiRetrieveResponse200 = {
  data: GlobalReport
  status: 200
}
    
export type adsCampaignsRoiRetrieveResponseSuccess = (adsCampaignsRoiRetrieveResponse200) & {
  headers: Headers;
};
;

export type adsCampaignsRoiRetrieveResponse = (adsCampaignsRoiRetrieveResponseSuccess)

export const getAdsCampaignsRoiRetrieveUrl = (params?: AdsCampaignsRoiRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/ads/campaigns/roi/?${stringifiedParams}` : `/api/v1/ads/campaigns/roi/`
}

export const adsCampaignsRoiRetrieve = async (params?: AdsCampaignsRoiRetrieveParams, options?: RequestInit): Promise<adsCampaignsRoiRetrieveResponse> => {
  
  return apiFetch<adsCampaignsRoiRetrieveResponse>(getAdsCampaignsRoiRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAdsCampaignsRoiRetrieveQueryKey = (params?: AdsCampaignsRoiRetrieveParams,) => {
    return [
    `/api/v1/ads/campaigns/roi/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdsCampaignsRoiRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>, TError = unknown>(params?: AdsCampaignsRoiRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdsCampaignsRoiRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>> = ({ signal }) => adsCampaignsRoiRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdsCampaignsRoiRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>>
export type AdsCampaignsRoiRetrieveQueryError = unknown


export function useAdsCampaignsRoiRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>, TError = unknown>(
 params: undefined |  AdsCampaignsRoiRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCampaignsRoiRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>, TError = unknown>(
 params?: AdsCampaignsRoiRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCampaignsRoiRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>, TError = unknown>(
 params?: AdsCampaignsRoiRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdsCampaignsRoiRetrieve<TData = Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>, TError = unknown>(
 params?: AdsCampaignsRoiRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCampaignsRoiRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdsCampaignsRoiRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * D-111: generated visuals of the Academy campaign templates (square, story, landscape).
 */
export type adsCreativesListResponse200 = {
  data: PaginatedAdCreativeList
  status: 200
}
    
export type adsCreativesListResponseSuccess = (adsCreativesListResponse200) & {
  headers: Headers;
};
;

export type adsCreativesListResponse = (adsCreativesListResponseSuccess)

export const getAdsCreativesListUrl = (params?: AdsCreativesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/ads/creatives/?${stringifiedParams}` : `/api/v1/ads/creatives/`
}

export const adsCreativesList = async (params?: AdsCreativesListParams, options?: RequestInit): Promise<adsCreativesListResponse> => {
  
  return apiFetch<adsCreativesListResponse>(getAdsCreativesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAdsCreativesListQueryKey = (params?: AdsCreativesListParams,) => {
    return [
    `/api/v1/ads/creatives/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdsCreativesListQueryOptions = <TData = Awaited<ReturnType<typeof adsCreativesList>>, TError = unknown>(params?: AdsCreativesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCreativesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdsCreativesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adsCreativesList>>> = ({ signal }) => adsCreativesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adsCreativesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdsCreativesListQueryResult = NonNullable<Awaited<ReturnType<typeof adsCreativesList>>>
export type AdsCreativesListQueryError = unknown


export function useAdsCreativesList<TData = Awaited<ReturnType<typeof adsCreativesList>>, TError = unknown>(
 params: undefined |  AdsCreativesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCreativesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCreativesList>>,
          TError,
          Awaited<ReturnType<typeof adsCreativesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCreativesList<TData = Awaited<ReturnType<typeof adsCreativesList>>, TError = unknown>(
 params?: AdsCreativesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCreativesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCreativesList>>,
          TError,
          Awaited<ReturnType<typeof adsCreativesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCreativesList<TData = Awaited<ReturnType<typeof adsCreativesList>>, TError = unknown>(
 params?: AdsCreativesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCreativesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdsCreativesList<TData = Awaited<ReturnType<typeof adsCreativesList>>, TError = unknown>(
 params?: AdsCreativesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCreativesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdsCreativesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * D-111: generated visuals of the Academy campaign templates (square, story, landscape).
 */
export type adsCreativesCreateResponse201 = {
  data: AdCreative
  status: 201
}
    
export type adsCreativesCreateResponseSuccess = (adsCreativesCreateResponse201) & {
  headers: Headers;
};
;

export type adsCreativesCreateResponse = (adsCreativesCreateResponseSuccess)

export const getAdsCreativesCreateUrl = () => {


  

  return `/api/v1/ads/creatives/`
}

export const adsCreativesCreate = async (adCreativeRequest: AdCreativeRequest, options?: RequestInit): Promise<adsCreativesCreateResponse> => {
  
  return apiFetch<adsCreativesCreateResponse>(getAdsCreativesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adCreativeRequest,)
  }
);}




export const getAdsCreativesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCreativesCreate>>, TError,{data: AdCreativeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adsCreativesCreate>>, TError,{data: AdCreativeRequest}, TContext> => {

const mutationKey = ['adsCreativesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adsCreativesCreate>>, {data: AdCreativeRequest}> = (props) => {
          const {data} = props ?? {};

          return  adsCreativesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdsCreativesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adsCreativesCreate>>>
    export type AdsCreativesCreateMutationBody = AdCreativeRequest
    export type AdsCreativesCreateMutationError = unknown

    export const useAdsCreativesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCreativesCreate>>, TError,{data: AdCreativeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adsCreativesCreate>>,
        TError,
        {data: AdCreativeRequest},
        TContext
      > => {

      const mutationOptions = getAdsCreativesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-111: generated visuals of the Academy campaign templates (square, story, landscape).
 */
export type adsCreativesRetrieveResponse200 = {
  data: AdCreative
  status: 200
}
    
export type adsCreativesRetrieveResponseSuccess = (adsCreativesRetrieveResponse200) & {
  headers: Headers;
};
;

export type adsCreativesRetrieveResponse = (adsCreativesRetrieveResponseSuccess)

export const getAdsCreativesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/ads/creatives/${id}/`
}

export const adsCreativesRetrieve = async (id: string, options?: RequestInit): Promise<adsCreativesRetrieveResponse> => {
  
  return apiFetch<adsCreativesRetrieveResponse>(getAdsCreativesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAdsCreativesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/ads/creatives/${id}/`
    ] as const;
    }

    
export const getAdsCreativesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adsCreativesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCreativesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdsCreativesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adsCreativesRetrieve>>> = ({ signal }) => adsCreativesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adsCreativesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdsCreativesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adsCreativesRetrieve>>>
export type AdsCreativesRetrieveQueryError = unknown


export function useAdsCreativesRetrieve<TData = Awaited<ReturnType<typeof adsCreativesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCreativesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCreativesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adsCreativesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCreativesRetrieve<TData = Awaited<ReturnType<typeof adsCreativesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCreativesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adsCreativesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adsCreativesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdsCreativesRetrieve<TData = Awaited<ReturnType<typeof adsCreativesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCreativesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdsCreativesRetrieve<TData = Awaited<ReturnType<typeof adsCreativesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adsCreativesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdsCreativesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * D-111: generated visuals of the Academy campaign templates (square, story, landscape).
 */
export type adsCreativesDestroyResponse204 = {
  data: void
  status: 204
}
    
export type adsCreativesDestroyResponseSuccess = (adsCreativesDestroyResponse204) & {
  headers: Headers;
};
;

export type adsCreativesDestroyResponse = (adsCreativesDestroyResponseSuccess)

export const getAdsCreativesDestroyUrl = (id: string,) => {


  

  return `/api/v1/ads/creatives/${id}/`
}

export const adsCreativesDestroy = async (id: string, options?: RequestInit): Promise<adsCreativesDestroyResponse> => {
  
  return apiFetch<adsCreativesDestroyResponse>(getAdsCreativesDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getAdsCreativesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCreativesDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adsCreativesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['adsCreativesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adsCreativesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  adsCreativesDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdsCreativesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adsCreativesDestroy>>>
    
    export type AdsCreativesDestroyMutationError = unknown

    export const useAdsCreativesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adsCreativesDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adsCreativesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAdsCreativesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    